import axios from "axios"
import { SAVE_PARTNER_WITH_US_URL,GET_PARTNER_WITH_US_URL } from "../Utils/URLs"
import { useState,useContext } from "react"
import { useNavigate } from "react-router-dom"
import { UserContext } from "./UserContext"
const PartnerWithUsState = ()=>{
const [formBusy,setFormBusy] = useState(false)
const [response,setResponse] = useState("")
const [progress,setProgress] = useState(0)
const [loading,setLoading] = useState(false)
const [partnerWithUsData,setPartnerWithUsData] = useState([])
const token = localStorage.getItem("token")
const {setNotifications} = useContext(UserContext)
const navigate = useNavigate()
    const SavePartnerWithUs =  async (data)=>{
        try{
            setFormBusy(true)
        const res = await axios.post(SAVE_PARTNER_WITH_US_URL,data,{
       onUploadProgress:(ProgressEvent)=>{
        const { loaded, total } = ProgressEvent;

                const progressState = Math.round((loaded / total) * 100);
                setProgress(progressState)
               
                localStorage.setItem("progress",progressState)
       }     
        })
        
        setResponse(res.data)
        setFormBusy(false)
        }catch(error){
            console.log(error)
            setFormBusy(false)
        }
    }

    const GetPartnerWithUs = async()=>{
        try{
            setLoading(true)
            const res = await axios.get(GET_PARTNER_WITH_US_URL,{
                headers:{
                    Authorization:`Bearer ${token}`
                }
            })
            setPartnerWithUsData(res.data.response)
            if (res.data.notification.length !== 0) {
                res.data.notification.forEach((item) => {
                    setNotifications((prev) => {
                        if (prev) {
                            const exist = prev.find((e) => e._id === item._id);
                            
                            if (!exist) {
                                return [...prev, item];
                            }
                        } else {
                            return [item];
                        }
                        return prev;
                    });
                });
            }
            setLoading(false)
        }catch(error){
            console.log(error.response.data)
            if(error.response.data.msg==="token_error"){
                localStorage.clear()
                navigate("/driver_forms/login")
            }
        }
    }

return{
    SavePartnerWithUs,
    formBusy,
    response,
    progress,
    GetPartnerWithUs,
    loading,
    partnerWithUsData
}

}

export default PartnerWithUsState